import * as React from 'react';
export const IcFertilized = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.56 13a2.59 2.59 0 00-1.76.8 2.41 2.41 0 00-.8 2.08.49.49 0 01-.19.36c-.15.13-.21.14-.54.13a2.57 2.57 0 00-2.75 2.35c-.05.33-.06.39-.21.52a1 1 0 001.3 1.52A2.579 2.579 0 005.54 19c0-.33.06-.39.21-.52s.22-.13.55-.13a2.58 2.58 0 001.86-.62c.251-.201.462-.45.62-.73a2.66 2.66 0 001.42-.76 2 2 0 00.4-2.8A1.44 1.44 0 009.56 13zM14 3a7 7 0 00-6.78 8.73A4.33 4.33 0 019.56 11 3.399 3.399 0 0112 12a3.491 3.491 0 011 3 4.49 4.49 0 01-.69 1.78A7 7 0 1014 3zm0 8.5a1.499 1.499 0 110-2.998 1.499 1.499 0 010 2.998z'
      fill='currentColor'
    />
  </svg>
);
